import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["cells", "key"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import withDimensions from '../../hoc/withDimensions';
import { inlineStylesIfRanking } from '../../internal/helpers';
import { RankableTableBodyRow } from '../../styled/rankable/TableRow';
import TableCell from './TableCell';
export var RankableTableRow = /*#__PURE__*/function (_React$Component) {
  _inherits(RankableTableRow, _React$Component);

  var _super = _createSuper(RankableTableRow);

  function RankableTableRow() {
    var _this;

    _classCallCheck(this, RankableTableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "innerRef", function (innerRefFn) {
      return function (ref) {
        innerRefFn(ref);

        if (typeof _this.props.innerRef === 'function') {
          _this.props.innerRef(ref);
        }
      };
    });

    return _this;
  }

  _createClass(RankableTableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          row = _this$props.row,
          head = _this$props.head,
          isFixedSize = _this$props.isFixedSize,
          isRanking = _this$props.isRanking,
          refWidth = _this$props.refWidth,
          rowIndex = _this$props.rowIndex,
          isRankingDisabled = _this$props.isRankingDisabled,
          isHighlighted = _this$props.isHighlighted,
          testId = _this$props.testId;

      var cells = row.cells,
          key = row.key,
          restRowProps = _objectWithoutProperties(row, _excluded);

      var inlineStyles = inlineStylesIfRanking(isRanking, refWidth);

      if (typeof key !== 'string' && !isRankingDisabled) {
        throw new Error('dynamic-table: ranking is not possible because table row does not have a key. Add the key to the row or disable ranking.');
      }

      return /*#__PURE__*/React.createElement(Draggable, {
        draggableId: key || rowIndex.toString(),
        index: rowIndex,
        isDragDisabled: isRankingDisabled
      }, function (provided, snapshot) {
        return /*#__PURE__*/React.createElement(RankableTableBodyRow, _extends({}, restRowProps, provided.dragHandleProps, provided.draggableProps, {
          ref: _this2.innerRef(provided.innerRef),
          style: _objectSpread(_objectSpread({}, provided.draggableProps.style), inlineStyles),
          isHighlighted: isHighlighted,
          isRanking: isRanking,
          isRankingItem: snapshot.isDragging
        }), cells.map(function (cell, cellIndex) {
          var headCell = (head || {
            cells: []
          }).cells[cellIndex];
          return /*#__PURE__*/React.createElement(TableCell, {
            head: headCell,
            cell: cell,
            isRanking: isRanking,
            key: cell.key || cellIndex,
            isFixedSize: isFixedSize,
            testId: testId
          });
        }));
      });
    }
  }]);

  return RankableTableRow;
}(React.Component);
export default withDimensions(RankableTableRow);